export enum SessionStorageKeys {
    EMAIL = 'email',
    ROOT = 'root',
    ALLOWED_ACCESS = 'allowedAccess',
    TRANSACTION_ID = 'transactionId',
    LOGIN_STEP = 'loginStep',
    GOOGLE_TOKEN = 'googleToken',
  }
  
export class SessionStorageService {
    setItem<T>(key: SessionStorageKeys, value: T): void {
      try {
        const stringValue = JSON.stringify(value);
        sessionStorage.setItem(key, stringValue);
      } catch (error) {
        console.error('Error setting session storage item:', error);
      }
    }
  
    getItem<T>(key: SessionStorageKeys): T | null {
      try {
        const storedValue = sessionStorage.getItem(key);
        return storedValue ? JSON.parse(storedValue) : null;
      } catch (error) {
        console.error('Error getting session storage item:', error);
        return null;
      }
    }
  
    removeItem(key: SessionStorageKeys): void {
      try {
        sessionStorage.removeItem(key);
      } catch (error) {
        console.error('Error removing session storage item:', error);
      }
    }
  
    clear(): void {
      try {
        sessionStorage.clear();
      } catch (error) {
        console.error('Error clearing session storage:', error);
      }
    }
  }
  
  export default SessionStorageService;
  